<p-toast
  styleClass="rx-toast"
  [position]="position"
  [hideTransitionOptions]="hideTransitionOptions"
  [showTransformOptions]="showTransformOptions"
>
  <ng-template let-message pTemplate="message">
    <div class="d-flex">
      <rx-icon-legacy [icon]="message.severity === 'success' ? 'rx-checkmark' : 'rx-close'"/>
      <span class="ml-3">{{ message.detail }}</span>
    </div>
  </ng-template></p-toast
>
